<template>
  <v-container fluid>
    <payroll-e-letter-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollELetterContainerView: () => import('@/components/hris/payroll/e-letter/ELetterReport'),
    },
    metaInfo () {
      return {
        title: 'Payroll E-Letter',
      }
    },
  }
</script>
